import { NotificationConfiguration } from '../notification.templates';

export const CR_CANCEL_CIRCULAR_RESOLUTION_TEMPLATE: NotificationConfiguration = {
  inapp: `The circular resolution has been <b>canceled</b>.`,
  email: {
    ctaKey: 'go_to_cr',
  },
};
